import { PickupParticipantDetailPage } from "components/shared/pickupParticipants";
import { InformationSection } from "./components/detail/informationSection";
import { PickupInformationSection } from "./components/detail/pickupInformationSection";
import { RegistrationInformationSection } from "./components/detail/registrationInformationSection";

export const PickupSportParticipantDetail: React.FC = () => (
  <PickupParticipantDetailPage
    kind="sport"
    variant="admin"
    sections={{
      InformationSection,
      RegistrationInformationSection,
      PickupInformationSection,
    }}
  />
);
